<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">


    <div class="spacer2"></div>

    <div class="containter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Interactions
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          Interactions log all user activities like adding or retrieving
          memories, reminders, and more.
        </div>
      </div>

      <div class="spacer2"></div>

      <div class="example-container">
        <!-- *ngIf="interactions?.data?.data?.interactions?.length" -->
        <table
          mat-table
          [dataSource]="interactions?.data?.data?.interactions"
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="accountHolder">
            <th mat-header-cell *matHeaderCellDef>Profile</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.mAccountHolder?.holderName }}<br />
              {{ element?.mAccountHolder?.holderId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="transaction">
            <th mat-header-cell *matHeaderCellDef>Interaction</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.transactionNumber }}<br />
              {{
                element?.transactionDateTime
                  | tzfmt : "yyyy-MM-dd HH:mm:ss" : appService.TimeZoneName
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="terminalName">
            <th mat-header-cell *matHeaderCellDef>Workspace</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.terminal.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="intentionPrimary">
            <th mat-header-cell *matHeaderCellDef>Intent</th>
            <td mat-cell *matCellDef="let element">
              <div
                class="cad"
                *ngIf="
                  element?.additionalParameters?.Traits?.psychologicalAnalysis
                    ?.intention?.primary
                "
              >
                {{
                  element?.additionalParameters?.Traits?.psychologicalAnalysis?.intention?.primary.toString()
                    | titlecase
                }}
              </div>
              <div
                class="cad"
                *ngIf="
                  !element?.additionalParameters?.Traits?.psychologicalAnalysis
                    ?.intention?.primary
                "
              >
                Other
              </div>
              <!-- {{element?.additionalParameters?.Traits?.psychologicalAnalysis?.intention?.primary}} -->
            </td>
          </ng-container>

          <ng-container matColumnDef="additionalParameters">
            <th mat-header-cell *matHeaderCellDef>Analysis</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.additionalParameters?.Query }}<br />
              {{ element?.additionalParameters?.Intention }}<br />
              {{ element?.additionalParameters?.Action }}<br />
              {{ element?.additionalParameters?.Sentiment }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <!-- No data row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; height: 50vh;">
              {{ loading ? 'Loading...' : 'No data found' }}
            </td>
          </tr>
        </table>
      </div>
    </div>


    </div>
  </div>
</div>
